import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-driving-license-info',
  templateUrl: './driving-license-info.component.html',
  styleUrls: ['./driving-license-info.component.scss']
})
export class DrivingLicenseInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
